export default {
    translate(errorCode, fallbackMessage) {
        const messages = {
            member_is_active: {
                title: 'Subscription already active',
                message: 'Your subscription is already active. Please email us at <a href="mailto:help@mentalhealthacademy.net">help@mentalhealthacademy.net</a> for further assistance.'
            },
            cannot_decode_hashed_id: {
                message: 'Message about wrong promo code'
            },
            charge_failed: {
                message: 'Failed to process your payment. Please check your credit card details and try again.'
            },
            no_referral: {
                title: 'No referral heading here',
                message: 'No referral are passed....'
            },
            email_has_been_taken: {
                title: 'Email has been taken',
                message: `Please use an alternative email address to complete your registration or <a href="mailto:help@mentalhealthacademy.net">contact us</a> for further assistance`
            },
            // A promo page whose offer has closed: the payment intent refuses
            // a promo that is inactive or past its end_at.
            promo_has_ended: {
                title: 'This offer has ended',
                message: 'Sorry, this offer is no longer available. Please visit <a href="/join">our subscription page</a> for current options, or email us at <a href="mailto:help@mentalhealthacademy.net">help@mentalhealthacademy.net</a>.'
            },
            // The events API refuses payment once the event's on-demand
            // window (or the event itself) has ended.
            event_registration_closed: {
                title: 'Registration has closed',
                message: 'Sorry, registration for this event has closed. Please email us at <a href="mailto:help@mentalhealthacademy.net">help@mentalhealthacademy.net</a> if you have any questions.'
            },
            event_attendee_exists: {
                title: 'This email address is already registered',
                message: 'Our records show that you have already registered for this event using this email address. Please check your registration confirmation email for further details. <a href="mailto:help@mentalhealthacademy.net">Contact us</a> if you need any assistance.'
            },
            // Core's renew promo answers with this key; the copy is
            // member_is_active's, which the website's own renewal showed.
            member_is_active_renew: {
                title: 'Subscription already active',
                message: 'Your subscription is already active. Please email us at <a href="mailto:help@mentalhealthacademy.net">help@mentalhealthacademy.net</a> for further assistance.'
            },
            // The renew promo form (RegistrationPromoRenew), answered by
            // mha-usa-core. Keys are core's messages where it sends one.
            incorrect_password: {
                title: 'That password doesn\'t match',
                message: 'The password you entered doesn\'t match the one on your MHA account. Please try again, or use <a href="/login">Forgot Password</a> on the login page to reset it.'
            },
            member_does_not_exists: {
                title: 'We couldn\'t find your subscription',
                message: 'There\'s no MHA subscription linked to this email address. Please check it for typos, or email us at <a href="mailto:help@mentalhealthacademy.net">help@mentalhealthacademy.net</a> and we\'ll gladly help.'
            },
            renewal_payment_failed: {
                title: 'We couldn\'t process your payment',
                message: 'Please check your card details and try again. If it keeps happening, email us at <a href="mailto:help@mentalhealthacademy.net">help@mentalhealthacademy.net</a> and we\'ll sort it out for you.'
            },
            renewal_failed: {
                title: 'We couldn\'t complete your renewal',
                message: 'Something went wrong on our side. Please try again in a moment, or email us at <a href="mailto:help@mentalhealthacademy.net">help@mentalhealthacademy.net</a> and we\'ll be happy to help.'
            },
            incorrect_promo_type: {
                title: 'Process Failure',
                message: 'Something has gone wrong. Please try again or contact us.'
            },
            password_is_invalid: {
                title: 'Password is incorrect',
                message: 'Please try again or reset your password.'
            },
            // mha-usa-core's answer for an email that already holds a
            // membership (the website's own is email_has_been_taken).
            member_exists_already: {
                title: 'Email has been taken',
                message: `Please use an alternative email address to complete your registration or <a href="mailto:help@mentalhealthacademy.net">contact us</a> for further assistance`
            },
            member_enrolled_course_already: {
                title: 'Looks like you already own this course',
                message: 'Please check your Learning Portal under Credential Courses > View Courses to access this course. If you require further assistance, please contact us at <a href="mailto:help@mentalhealthacademy.net">help@mentalhealthacademy.net</a>.'
            },
            payment_intent_authentication_failure: {
                title: 'Please try again...',
                message: 'We had a little trouble authorizing your payment with your card issuer. Please try again. Thank you.'
            },
            card_declined: {
                title: 'Please try again...',
                message: 'Unfortunately your payment attempt was declined. Please try again and if the issue persists, email us for additional support. Thank you.'
            },
            payment_intent_invalid: {
                title: 'Please try again...',
                message: 'The payment information you provided is invalid. please contact us at <a href="mailto:help@mentalhealthacademy.net">help@mentalhealthacademy.net</a>. Thank you.'
            },
            payment_intent_authentication_failure_on_site: {
                title: 'Payment Confirmation Failure',
                message: 'Please contact us at <a href="mailto:help@mentalhealthacademy.net">help@mentalhealthacademy.net</a>. Thank you.'
            },
            attendee_has_full_access_already: {
                title: 'You Already Have Premium Access',
                message: 'Your attempt to make a payment was not processed because our records show that you already have Premium Access for this event.'
            },
            member_login_fail: {
                title: 'Login Failed',
                message: 'The email address or password you entered is incorrect. Please check your credentials and try again, or reset your password if you’ve forgotten it.'
            },
            email_not_found: {
                title: 'Email Address Not Found',
                message: 'The email address you provided does not match any records in our system. Please verify your email address and try again, or use a different email that may be associated with your account.'
            },
        };

        return messages[errorCode] || {
            title: 'Something didn\'t go as expected',
            message: fallbackMessage || 'Please reach out to us at <a href="mailto:help@mentalhealthacademy.net">help@mentalhealthacademy.net</a>, and we\'ll be happy to help.'
        };
    }
}
